import { render, staticRenderFns } from "./PopupContent.vue?vue&type=template&id=f415c320&scoped=true"
import script from "./PopupContent.vue?vue&type=script&lang=js"
export * from "./PopupContent.vue?vue&type=script&lang=js"
import style0 from "./PopupContent.vue?vue&type=style&index=0&id=f415c320&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f415c320",
  null
  
)

export default component.exports